module.exports = __webpack_public_path__ + "static/recruit-icon-woman01-cefae3bf9def384b76201a6deaa6e7e2.png";